import Grid from '@jobcost-monorepo/crud/ui/Grid';
import {
  IResourceSkillFetchParams,
  IResourceSkill,
  MN_RESOURCE_SKILLS,
} from '@jobcost-monorepo/crud';

export default function ResourceSkillsPage() {
  return (
    <Grid<IResourceSkill, IResourceSkillFetchParams>
      moduleName={MN_RESOURCE_SKILLS}
      updateStore={false}
    ></Grid>
  );
}
